import { render, staticRenderFns } from "./File.vue?vue&type=template&id=e0d7a1d2"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"
import style0 from "./File.vue?vue&type=style&index=0&id=e0d7a1d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports